import { formAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  formAnatomy.keys
);

const baseStyle = definePartsStyle({
  container: {}
});

const variants = {
  calculator: definePartsStyle({
    container: {
      marginBottom: '10px'
    }
  })
  // Add more variants if needed
};

export const formTheme = defineMultiStyleConfig({ baseStyle, variants });
